import { render, staticRenderFns } from "./lottery-popup-coupon.vue?vue&type=template&id=3bf6b096&scoped=true&"
import script from "./lottery-popup-coupon.vue?vue&type=script&lang=js&"
export * from "./lottery-popup-coupon.vue?vue&type=script&lang=js&"
import style0 from "./lottery-popup-coupon.vue?vue&type=style&index=0&id=3bf6b096&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6b096",
  null
  
)

export default component.exports